import React, { useContext } from 'react';

import LocaleContext from 'contexts/locale-context';

const Error = ({ message }) => {
  const { locale } = useContext(LocaleContext);

  return (
    <div className='error-container'>
      <h1>{message}</h1>
      <a href={`/${locale}`}>Home</a>
    </div>
  );
};

export default Error;